<script>
import { defineComponent } from 'vue';
import vueNumberInput from '@chenfengyuan/vue-number-input';
import Incrementer from '@/helpers/increment.js';
import Favorite from '@/components/global/Favorites.vue';

export default defineComponent({
    name: 'favoriteItem',
    setup() {},
    props: {
        item: Object,
        token: String
    },
    data() {
        return {
            qty: this.defaultIncrement
        }
    },
    methods: {
        returnCurrency(d) {
            return new Intl.NumberFormat('en-EN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(d)
        }
    },
    components: {
        vueNumberInput,
        Favorite
    },
    computed: {
        accessToken() {
            return this.$store.getters['auth/accessToken'];
        },
        price() {
            return new Intl.NumberFormat('en-EN', { minimumFractionDigits: 2, maximumFractionDigits:2 }).format(this.item.price)
        },
        defaultIncrement() {
            if (this.item.category=='WIRE') {
                return Incrementer.DefaultCutLength(this.item.itemNumber, "MFT");
            }
            return 1;
        },
        uom() {
            return this.item.category == 'WIRE' ? 'MFT' : 'EA';
        }
    },
    mounted() {
        this.qty = this.defaultIncrement;
    }
})
</script>

<template>
    <div>
        <div class="row q-mb-sm">
            <div class="col-7">
                <div class="row">
                    <div class="col-1 q-ml-md q-mt-sm">
                        <favorite :item="item.itemNumber" :accessToken="accessToken"></favorite>
                    </div>
                    <div class="col q-ml-md q-mt-sm text-left">
                        <h3 style="line-height: 1em;">{{item.itemNumber}} </h3>
                        <p class="productDescription">{{item.description}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-7 q-ml-md q-mt-sm">
                        <vue-number-input v-model.number="qty" :min="defaultIncrement" :step="defaultIncrement" :inputtable="false"  size="small" @input="onInput" controls center></vue-number-input>
                    </div>
                    <div class="col-3 q-mt-sm">
                        <q-btn color="cyan-7" size="md" :unelevated=true :ripple=true padding="3px 18px 3px 18px" icon="fas fa-cart-plus" class="q-ml-xs q-mb-sm" @click="$store.dispatch('cart/addToCart', [token, item.itemNumber, qty])"/>
                    </div>
                </div>
            </div>
            <div class="col-5 q-pl-md q-pr-lg">
                <div class="q-mt-sm q-mr-sm text-right">
                    <q-btn class="q-pa-sm q-mt-xs" color="warning" label="Request Price" icon="fas fa-dollar-sign" size="sm" v-if="price==0" style="height: 30px !important;width: 140px;"/>
                    <q-btn unelevated v-if="item.price>0" class="q-pa-sm q-mt-xs" color="positive" :label="`${price} ${uom}`" icon="fas fa-dollar-sign" style="height: 25px !important;width: 140px;"/>
                </div>
                <div class="q-pt-md q-mt-xs text-right q-mr-sm">
                    <q-btn size="sm" icon="fas fa-list wcwBlue" outline :ripple=true  label="Add To List" color="cyan-7" text-color="cyan-7" @click="$store.commit('customer/setAddToList', item)" style="height: 29px !important;width: 140px;"/>
                </div>
            </div>
        </div>
        <div class="mobileDiv"></div>
    </div>
</template>

<style scoped>
    .productDescription{height: 32px;}
</style>
